import { styled, Button } from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";

/**
 * AppBars
 * Base footer AppBar (used when sidebar is not applied).
 * - White background
 * - Black text
 * - No shadow
 * - Fixed to bottom, full width
 */
export const AppBars = styled(MuiAppBar)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  color: theme.palette.common.black,
  borderTop: "1px solid #EAECF0", // subtle divider line
  bottom: 0,
  boxShadow: "none",
  width: "100%",
}));

/**
 * AppBar1
 * Footer AppBar that adapts to sidebar visibility.
 * - Shifts width/margin when sidebar is open or closed
 * - Smooth transition on toggle
 */
export const AppBar1 = styled(AppBars)(({ theme }) => ({
  marginLeft: theme.miniDrawerWidth, // start aligned with mini sidebar
  width: `calc(100% - ${theme.miniDrawerWidth})`,
  zIndex: theme.zIndex.drawer + 1,

  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),

  // Variant for when sidebar is fully open
  variants: [
    {
      props: ({ open }) => open,
      style: {
        marginLeft: theme.drawerWidth,
        width: `calc(100% - ${theme.drawerWidth})`,
        transition: theme.transitions.create(["width", "margin"], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
    },
  ],
}));

/**
 * AppBarButton
 * Custom-styled MUI button for footer links.
 * - Black text
 * - Underlined for "link" look
 */
export const AppBarButton = styled(Button)(({ theme }) => ({
  color: theme.palette.common.black,
  textDecoration: "underline",
}));
